export const processImageFile = async (file: File): Promise<File> => {
    const isHeic = file.type === 'image/heic' || file.type === 'image/heif' ||
        file.name.toLowerCase().endsWith('.heic') || file.name.toLowerCase().endsWith('.heif');

    if (!isHeic) {
        return file;
    }

    try {
        const heic2any = (await import('heic2any')).default;
        console.log('Converting HEIC file to JPEG...');
        const convertedBlob = await heic2any({
            blob: file,
            toType: 'image/jpeg',
            quality: 0.8
        });

        const blob = Array.isArray(convertedBlob) ? convertedBlob[0] : convertedBlob;

        const newFileName = file.name.replace(/\.heic$|\.heif$/i, '.jpg');
        return new File([blob], newFileName, { type: 'image/jpeg' });
    } catch (err) {
        console.error('Failed to convert HEIC to JPEG:', err);
        // Fallback to original, though it might fail later
        return file;
    }
};
